// extracted by mini-css-extract-plugin
module.exports = {"grid__button":"styles_grid__button__eIDQC"};